import React, { useState } from 'react';
import { FormControl } from 'react-bootstrap';
import { RiSearchLine } from '@react-icons/all-files/ri/RiSearchLine';
import classNames from 'classnames';
import './styles.scss';

interface SearchBarProps {
    placeholder?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
    searchClassName?: string;
}

const SearchBar = ({ placeholder = 'Search', onChange, value, searchClassName }: SearchBarProps) => {
    const [isActive, setIsActive] = useState<boolean>(false);

    const handleFocus = () => {
        setIsActive(true);
    };

    const handleBlur = () => {
        setIsActive(false);
    };

    const className = classNames('position-relative', 'search-container', {
        'bg-transparent text-primary': isActive,
    });

    return (
        <div className={className} data-testid="search-bar">
            <RiSearchLine className="search-container__search-icon position-absolute text-text-low-emphasis" />
            <FormControl
                className={`search-container__search-input border-grey-50 rounded  bg-transparent ${searchClassName}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                data-testid="search-input"
            />
        </div>
    );
};

export default SearchBar;
